import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import { createPinia } from 'pinia';
import { createApp, type Component } from 'vue';

import App from './App.vue';
import router from './router';

import './styles/main.css';

const app = createApp(App as Component);

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.use(createPinia());
app.use(router);
// 全局中文语言包（日期选择器、分页等组件文案）
app.use(ElementPlus, { locale: zhCn });

app.mount('#app');
